import { RefObject, useEffect, useState } from 'react';

export default function useScrollHeight(ref: RefObject<HTMLElement | null>) {
  const [scrollHeight, setScrollHeight] = useState<number | undefined>(
    undefined,
  );

  useEffect(() => {
    function getSize(ref: RefObject<HTMLElement | null>): number | undefined {
      if (!ref.current) {
        return undefined;
      }

      return ref.current.scrollHeight;
    }

    function onResize() {
      setScrollHeight(getSize(ref));
    }

    onResize();

    const resizeObserver = new ResizeObserver(onResize);
    if (ref.current) {
      resizeObserver.observe(ref.current);
    }

    return () => {
      resizeObserver.disconnect();
    };
  }, [ref]);

  return scrollHeight;
}
